// SetRoleForm.js
import React, { useState, useContext } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import { AuthContext } from '../AuthContextProvider';
import { useNavigate } from 'react-router-dom';
import ErrorDialog from '../ErrorDialog';
import '../App.css';

const SetRoleForm = () => {
  const [role, setRole] = useState('');
  const { user, setLoginRole } = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const navigate = useNavigate();

  const handleChange = (event) => {
    setRole(event.target.value);
  };

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      if (role === '') {
        throw new Error("Role is required");
      }
      setLoginRole(user, role);
      navigate('/home');
    } catch (err) {
      console.error(err);
      setErrorMessage(`failed to set role ${err}`);
      setOpenErrorDialog(true);
    }
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const getRoleItems = () => {
    let items = [];
    user.roles.forEach((role, i) => {
      items.push(<MenuItem value={role} key={`${role}${i}`}>{role}</MenuItem>);
    });
    return items;
  };

  return (
    <div className="RoleForm">
      <FormControl className="Select" sx={{marginBottom: "1em", width: 600}}>
        <InputLabel className="Select" id="role-select-label">Select Role</InputLabel>
        <Select
          className="Select"
          labelId="role-select-label"
          id="role-select"
          value={role}
          label="Select Role"
          onChange={handleChange}
        >
          {getRoleItems()}
        </Select>
      </FormControl>
      <Button className="Button" type="submit" variant="contained" color="primary" onClick={handleSubmit}>
        Set Role
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default SetRoleForm;
